exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".last-panel a[data-v-2964aa1e]{position:relative;display:block;text-align:center;margin-top:1.5em;padding:1em}.last-panel a i[data-v-2964aa1e]{margin-right:1em}.download-button[data-v-2964aa1e]{border:3px solid #334e61}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2964aa1e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tabs/Terms.vue
// module id = 77
// module chunks = 0